/*
 * @Descripttion: 敏感信息解密接口
 * @version:
 * @Author:
 * @Date: 2026-06-12
 * @LastEditors:
 * @LastEditTime: 2026-06-12
 */
import request from '@/service/request'

enum Api {
  /** 敏感信息解密 */
  SENSITIVE_DECRYPT = '/sensitive/decrypt'
}

export default class sensitiveService {
  /**
   * 敏感信息解密
   * @param data 解密参数 { key: 列表id, code: 页面编码, menuName: 页面名称 }
   * @returns 明文数据
   */
  static decrypt(data: any): Promise<any> {
    return request.post(Api.SENSITIVE_DECRYPT, data)
  }
}
